import CompanyDetail from "../../Company/CompanyDetail";
import Modal from "../Modal";
import { useState } from "react";
import { useTranslation } from "../../../hooks/useTranslation";

export default function CompanyDetailModal({ company_id, onHide }) {
  const { t } = useTranslation();
  const [title, setTitle] = useState(t("companies.detail"));
  return (
    <Modal
      show={company_id}
      width="1000px"
      handleClose={() => onHide()}
      title={title}
    >
      <div style={{ maxHeight: "70vh", overflow: "auto" }}>
        <div style={{ width: "99%" }}>
          <CompanyDetail
            company_id={company_id}
            isModal={true}
            setTitle={(title) => setTitle(title)}
          />
        </div>
      </div>
    </Modal>
  );
}
